(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spooky-savings-page"]) return;
  try {
    
  function bindSpookySavingsHeroMotion() {
    var finePointer = window.matchMedia('(pointer: fine)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    document.querySelectorAll('.spooky-savings-page').forEach(function (page) {
      if (page.dataset.spookyMotionBound) return;
      page.dataset.spookyMotionBound = 'true';
      var hero = page.querySelector('.spooky-savings-page__hero');
      var control = page.querySelector('.spooky-savings-page__motion-control');
      var label = control.querySelector('.spooky-savings-page__motion-label');
      var icon = control.querySelector('[aria-hidden="true"]');
      var frame = 0;
      var x = 0;
      var y = 0;
      var userPaused = false;
      try { userPaused = window.localStorage.getItem('spookySavingsMotionPaused') === 'true'; } catch (error) {}

      function clearPointerMotion() {
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
        hero.style.removeProperty('--spooky-hero-x');
        hero.style.removeProperty('--spooky-hero-y');
      }

      function syncMotion() {
        var paused = reducedMotion.matches || userPaused;
        page.classList.toggle('spooky-savings-page--motion-paused', paused);
        control.disabled = reducedMotion.matches;
        control.setAttribute('aria-pressed', paused ? 'true' : 'false');
        label.textContent = reducedMotion.matches ? 'Motion off in device settings' : paused ? 'Play motion' : 'Pause motion';
        icon.textContent = paused ? '▶' : 'Ⅱ';
        if (paused) clearPointerMotion();
      }

      control.addEventListener('click', function () {
        userPaused = !userPaused;
        try { window.localStorage.setItem('spookySavingsMotionPaused', String(userPaused)); } catch (error) {}
        syncMotion();
      });

      if (reducedMotion.addEventListener) {
        reducedMotion.addEventListener('change', syncMotion);
      } else if (reducedMotion.addListener) {
        reducedMotion.addListener(syncMotion);
      }

      hero.addEventListener('pointermove', function (event) {
        if (!finePointer.matches || reducedMotion.matches || userPaused) return;
        var bounds = hero.getBoundingClientRect();
        x = ((event.clientX - bounds.left) / bounds.width - .5) * -34;
        y = ((event.clientY - bounds.top) / bounds.height - .5) * -20;
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          hero.style.setProperty('--spooky-hero-x', x.toFixed(1) + 'px');
          hero.style.setProperty('--spooky-hero-y', y.toFixed(1) + 'px');
          frame = 0;
        });
      }, { passive: true });
      hero.addEventListener('pointerleave', clearPointerMotion);
      syncMotion();
      page.classList.add('spooky-savings-page--motion-ready');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSpookySavingsHeroMotion);
  } else {
    bindSpookySavingsHeroMotion();
  }
  document.addEventListener('shopify:section:load', bindSpookySavingsHeroMotion);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.spooky-savings-page .spooky-carousel__arrow');
    if (!button) return;
    var carousel = button.closest('.spooky-carousel');
    var track = carousel && carousel.querySelector('.spooky-carousel__track');
    var card = track && track.querySelector('.spooky-carousel__item');
    if (!card) return;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var direction = button.dataset.spookyDirection === 'previous' ? -1 : 1;
    var page = button.closest('.spooky-savings-page');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var paused = page && page.classList.contains('spooky-savings-page--motion-paused');
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap) * 2, behavior: reducedMotion || paused ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
